import { Card, Grid, List, makeStyles } from "@material-ui/core"
import Typography from '@material-ui/core/Typography';
import { ItemAportesEmpresas } from "./ItemAportesEmpresas";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchAportesPreafiliado } from "../../actions/aportesPreafiliado";

const useStyles = makeStyles({
  root: {
    //background:"#efebe9",
    margin:30
  },
  tittle:{
      margin:30
  },
  list:{
    width: '100%',
    //maxWidth: 360,
    //backgroundColor: "#efebe9",
  }
});
export const CardAportEmpresas = (props) => {
    const classes = useStyles();
    const {items,cargada} = useSelector(state=>state.aportesPreafiliado)
    const {afiliadoEncontrado} = useSelector(state=>state.preinscripto)

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchAportesPreafiliado(afiliadoEncontrado.cuil))
    }, [afiliadoEncontrado.cuil, dispatch])
    return(
    <Grid container justify="center" >
        {
            !cargada?
            <Grid container item justify="center" className={classes.tittle}>
                <Typography variant="h4">No tiene Aportes...</Typography>
            </Grid>:
            <Grid item>
                <Grid item container justify="center"><Typography variant="h5">Aportes Declarados</Typography></Grid> 
                <Card className={classes.list}>
                    <List dense className={classes.root}>
                        {
                            items.map(item => <ItemAportesEmpresas item={item}/>)
                        }
                    </List>
                </Card>
            </Grid>
        }
    </Grid>
    )
}